<template>
    <v-chip
        v-bind="$attrs"
        :baseColor="baseColor"
        :color="color"
        :text="text"
        :closable="closable"
        :selected="selected"
        :variant="variant"
        :prependIcon="prependIcon"
        :density="density"
        :border="border"
        :size="size"
    />
</template>

<script setup lang="ts">
    defineProps<{
        baseColor?: string;
        color?: string;
        text?: string;
        closable?: boolean;
        selected?: boolean;
        variant?: 'text' | 'flat' | 'elevated' | 'tonal' | 'outlined' | 'plain';
        prependIcon?: string;
        density?: 'default' | 'comfortable' | 'compact';
        border?: string | number | boolean;
        size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large';
    }>();
</script>
